'use client'

import { useTheme } from '@/lib/theme'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'
  return (
    <button onClick={toggleTheme} style={{ height: 40, width: 40, boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg-card, #fff)', border: '1.5px solid var(--color-text-muted)', borderRadius: 8, cursor: 'pointer', padding: 0, color: 'var(--color-text-primary)', fontSize: '1rem', fontWeight: 600, lineHeight: 1 }} aria-label="Toggle theme">{isDark ? '☀' : '☾'}</button>
  )
}
